// src/components/fnct/IconeRapport.tsx — SCE Issues
// « Ceci part dans le rapport client » (refonte de la fiche FNC-T, 12/10) :
// une petite icône de document à côté de ce que le rapport GP-219E-02 reprend
// (description, documents et tests impactés, actions, clôture), le détail au
// survol. Remplace les pastilles « rapport client » / « interne » de la
// maquette : ce qui n'a pas l'icône reste interne (Guillaume, 12/10).
// Au toucher, pas de survol : la légende en tête du constat le dit une fois.

import type { JSX } from 'react'
import { FileText } from 'lucide-react'
import { Infobulle } from '@/components/ui/Infobulle'

export function IconeRapport({ detail }: { detail: string }): JSX.Element {
  return (
    <Infobulle titre="Part dans le rapport client" detail={detail}>
      <span
        role="img"
        aria-label={`Part dans le rapport client : ${detail}`}
        title={detail}
        className="inline-flex items-center justify-center flex-shrink-0"
        style={{
          width: 22,
          height: 22,
          borderRadius: 11,
          border: '1px solid var(--color-gray-30)',
          backgroundColor: 'var(--color-white)',
          color: 'var(--color-gray-90)',
          cursor: 'help',
          verticalAlign: 'middle',
        }}
      >
        <FileText size={12} strokeWidth={2.25} aria-hidden="true" />
      </span>
    </Infobulle>
  )
}
